<template>
  <div class="b-booking-progress">
    <div class="b-booking-progress__desktop">
      <div class="b-booking-progress__wrapper">
        <div class="b-booking-progress__selected-movie">
          <div
            v-if="currentStep === 1"
            class="b-canteen-progress-bar__container"
            @click="removeCinemaChoice">
            <div class="b-canteen-progress-bar__cinema-container">
              <div
                class="b-canteen-progress-bar__holder__address"
                v-html="selectedCinema.address"></div>
              <div class="b-canteen-progress-bar__holder__name">
                {{ selectedCinema.display }}
              </div>
            </div>
            <div class="e-custom-select__btn">
              <i class="icon-arrow-right-up"></i>
            </div>
          </div>
          <div
            v-if="currentStep === 2"
            class="b-canteen-progress-bar__cinema-details">
            <div class="b-canteen-progress-bar__final-container__title">
              {{ dictionary.villageCinemas }}
            </div>
            <div>
              <div class="b-canteen-progress-bar__final-container__title">
                {{ selectedCinema.display }}
              </div>
              <div
                class="b-canteen-progress-bar__final-container__cinema-address"
                v-html="selectedCinema.address"></div>
            </div>
          </div>
          <div class="b-booking-progress__actions">
            <button
              v-if="disabledPrevButton"
              type="button"
              class="b-booking-progress__actions__cta__prev"
              @click="restartBooking">
              <span>{{ dictionary.buttonPreviousText }}</span>
            </button>
            <button
              type="button"
              class="b-booking-progress__actions__cta__next btn-primary-orange"
              :disabled="selectedProductsInProgress"
              @click="goToNextStep">
              <span>{{ nextBtnTitle }}</span>
            </button>
          </div>
          <!-- progress bar -->
          <div
            class="b-booking-progress__progress-bar"
            :style="progressStyle"></div>
        </div>
      </div>
    </div>
    <div class="b-booking-progress__mobile">
      <div class="b-booking-progress__wrapper--canteen">
        <div
          v-if="currentStep === 1"
          class="b-booking-progress__wrapper--canteen__price">
          {{ roundToDigits(totalCartAmount) }} €
        </div>
        <button
          type="button"
          class="btn-primary-orange"
          :class="{ 'btn--block': currentStep === 2 }"
          :disabled="selectedProductsInProgress"
          @click="goToNextStep">
          <span>{{ nextBtnTitle }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { useBookingStore } from '../store/BookingStore'

export default {
  props: {
    currentStep: { default: 1, type: Number },
  },
  emits: ['go-to-next', 'restart-booking', 'remove-cinema-choice'],
  setup() {
    return { store: useBookingStore() }
  },
  computed: {
    progressStyle() {
      return `--progress: ${this.currentStep * 40}`
    },
    disabledPrevButton() {
      return this.currentStep === 2
    },
    selectedProductsInProgress() {
      const { paymentDetails, userShopItems } = this.store.bookingProgress
      if (this.currentStep === 1) {
        return !Object.keys(userShopItems).length
      } else if (this.currentStep === 2) {
        return paymentDetails.invalid
      }
      return false
    },
    nextBtnTitle() {
      return this.currentStep === 1
        ? this.dictionary.buttonNextText
        : this.dictionary.buttonNextPaymentText
    },
    selectedCinema() {
      return this.store.getSelectedCinema
    },
    totalCartAmount() {
      return this.store.getTotalSelectedProducts
    },
  },
  methods: {
    restartBooking() {
      this.$emit('restart-booking')
    },

    goToNextStep() {
      this.$emit('go-to-next')
    },
    removeCinemaChoice() {
      this.$emit('remove-cinema-choice')
    },
    roundToDigits(price) {
      return (
        price &&
        parseFloat(price).toLocaleString(document.documentElement.lang, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      )
    },
  },
}
</script>
